import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
//eslint-disable-next-line
const seniorenConfig = {
    apiKey: "AIzaSyAcDF3TsBnw6B_jsF-4StsvMyiDMjy2uFE",
    authDomain: "simplemessageboard-a3115.firebaseapp.com",
    databaseURL: "https://simplemessageboard-a3115.firebaseio.com",
    projectId: "simplemessageboard-a3115",
    storageBucket: "simplemessageboard-a3115.appspot.com",
    messagingSenderId: "428797085249"
};
//eslint-disable-next-line
const genbundConfig= {
    apiKey: "AIzaSyC4_rEvYv0JkEuMxY4WspUMOvlqOMzxULI",
    authDomain: "generationlink-53957.firebaseapp.com",
    databaseURL: "https://generationlink-53957.firebaseio.com",
    projectId: "generationlink-53957",
    storageBucket: "generationlink-53957.appspot.com",
    messagingSenderId: "161347805669"
}
//eslint-disable-next-line
const devConfig = {
  apiKey: "AIzaSyDbovfnrwroYitLPQHrjzi2zMGEyTCgk9E",
  authDomain: "devstage-e4e4e.firebaseapp.com",
  databaseURL: "https://devstage-e4e4e.firebaseio.com",
  projectId: "devstage-e4e4e",
  storageBucket: "devstage-e4e4e.appspot.com",
  messagingSenderId: "1072775914464",
  appId: "1:1072775914464:web:8fde59b1f6e11058"
};


const config = genbundConfig
if (!firebase.apps.length) {
  firebase.initializeApp(config);

}

const db = firebase.database();
const auth = firebase.auth();



export {
  db,
  auth,
  config,
  firebase
};



// WEBPACK FOOTER //
// ./src/firebase/firebase.js